import { Dialog } from '@angular/cdk/dialog'
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  MatPaginatorModule,
  MatPaginator,
  MatPaginatorIntl,
} from '@angular/material/paginator'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'
import { Subject, firstValueFrom } from 'rxjs'
import { DialogService } from '../../../../services/dialog.service'
import { ErrorService } from '../../../../services/error.service'
import { IntegrationService } from '../../../../services/integration.service'
import { SpinnerService } from '../../../../services/spinner.service'
import { ApiError } from '../../../../types/apiError'
import { Integration } from '../../../../types/integrations'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatIcon } from '@angular/material/icon'
import { ClipboardModule } from '@angular/cdk/clipboard'
import { PaginatorIntl } from '../../../intl/paginator-intl'
import { TranslationService } from '../../../../services/translation.service'

@Component({
  selector: 'app-integrations-list',
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatIcon,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntl,
    },
  ],
  templateUrl: './integrations-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './integrations-list.component.scss',
})
export class IntegrationsListComponent implements OnInit, AfterViewInit {
  @Input() refreshListSubject: Subject<boolean> = new Subject<boolean>()

  dialog = inject(Dialog)
  dialogService = inject(DialogService)
  errorService = inject(ErrorService)
  spinnerService = inject(SpinnerService)
  integrationService = inject(IntegrationService)
  translationService = inject(TranslationService)

  @ViewChild(MatPaginator) paginator!: MatPaginator
  integrations: Array<Integration> = []
  displayedColumns: string[] = ['apiKey', 'client', 'expiresAt', 'copy']
  dataSource = new MatTableDataSource<Integration>([])

  showApiKey: boolean = false

  async ngOnInit(): Promise<void> {
    // refreshes list after a new integration token is created from the parent
    this.refreshListSubject.subscribe(async (response) => {
      if (response) {
        await this.getResults()
      }
    })

    await this.getResults()
  }

  ngAfterViewInit(): void {
    // Assigns the paginator to table dataSource
    this.dataSource.paginator = this.paginator
  }

  /**
   * Retrieves active Integration Session
   */
  async getResults() {
    try {
      this.spinnerService.startSpinner()
      const response = await firstValueFrom(this.integrationService.getAll())
      this.integrations = response
      this.dataSource.data = this.integrations
      this.spinnerService.stopSpinner()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }
}
